import React,{useState,useEffect} from 'react'
import contactEditIcon from '../../../assets/images/contact-edit-icon.svg';
import { useSelector,useDispatch } from 'react-redux';
import moment from 'moment-timezone';
import sliderCloseIcon from '../../../assets/images/slider-close-icon.svg';
import { updatecustomMessage,fetchCustomMessages,isAdminUser,deleteCustomMessage } from '../../../redux/action';

export default function WaitTime() {
  const dispatch=useDispatch()
  const custommessages=useSelector((state)=>state.customMessages)
  const [defaultMessage,setDefaultMessage]=useState({})

  const [newMessageInfo,setNewMessageInfo]=useState({
    id:false,
    name:'',
    messageBody:'',
    startTime:'',
    endTime:'',
    days:{
        mon: false,
        tue: false,
        wed: false,
        thu: false,
        fri: false,
        sat: false,
        sun: false,
      }
  })

  const getCustomMessages=()=>{
    dispatch(fetchCustomMessages())
   }

   useEffect(()=>{
    getCustomMessages()
   },[])

  
  const clearState=()=>{
    setNewMessageInfo({
      id:false,
    name:'',
    messageBody:'',
    startTime:'',
    endTime:'',
    days:{
        mon: false,
        tue: false,
        wed: false,
        thu: false,
        fri: false,
        sat: false,
        sun: false,
      }
    })
  }

  const handleChangeInfo=(e)=>{
    let key=e.target.name;
    let value=e.target.value;
    setNewMessageInfo({
      ...newMessageInfo,
      [key]:value
    })
    }
  
    const updateDaysCheckBox=(target)=>{
      //let info =newMessageInfo 
      newMessageInfo.days[ target.name ] = false
      if( target.checked ){
        newMessageInfo.days[ target.name ] = true
      }
      setNewMessageInfo( {...newMessageInfo} )
    }

    const getEncodedDays=( days )=> {
        let daysArr = []
        if ( days.mon ) daysArr[daysArr.length] = 1 
        if ( days.tue ) daysArr[daysArr.length] = 2 
        if ( days.wed ) daysArr[daysArr.length] = 3 
        if ( days.thu ) daysArr[daysArr.length] = 4 
        if ( days.fri ) daysArr[daysArr.length] = 5 
        if ( days.sat ) daysArr[daysArr.length] = 6 
        if ( days.sun ) daysArr[daysArr.length] = 7 
        return JSON.stringify( daysArr )
      }
    
      const getDecodedDays=( daysStr )=>{
        let daysArr = JSON.parse(daysStr)
        let days = {
          mon: false,
          tue: false,
          wed: false,
          thu: false,
          fri: false,
          sat: false,
          sun: false,
        }
        for( var i = 0 ; i < daysArr.length ; i++ ){ 
          if( daysArr[i] == 1 ){
            days.mon = true
          }else if( daysArr[i] == 2 ){
            days.tue = true
          }else if( daysArr[i] == 3 ){
            days.wed = true
          }else if( daysArr[i] == 4 ){
            days.thu = true
          }else if( daysArr[i] == 5 ){
            days.fri = true
          }else if( daysArr[i] == 6 ){
            days.sat = true
          }else if( daysArr[i] == 7 ){
            days.sun = true
          }
        }
        return days
      }

      const customUpdateToggle = ( id ) => {
    
        clearState()
    
    
        let currentInfo= {}
        
        let info = custommessages.customWaitTime.find( x => x.id === id );
        currentInfo.id = info.id
        currentInfo.name = info.name
        currentInfo.messageBody = info.text_message
        currentInfo.days = getDecodedDays( info.active_days )
    
        let utcTime = moment.utc( info.start_time, ['h:m a', 'H:m'] ).local()
        currentInfo.startTime = utcTime.format('HH:mm:ss');
    
        utcTime = moment.utc( info.end_time, ['h:m a', 'H:m'] ).local()
        currentInfo.endTime = utcTime.format('HH:mm:ss');
        
        console.log(currentInfo)
    
        setNewMessageInfo(currentInfo)
        console.log(newMessageInfo)
      }

    const handleUpdateDefault=()=>{
        let form = new FormData()
        form.append('text_message', defaultMessage.text_message) 
        form.append('voice_message', "") 
        form.append('binary_files', "")
        form.append('message_type', 2)
        form.append('forward_type', 0)
        form.append('forward_date_time', null)
        form.append('is_active', 1)
  
          dispatch(updatecustomMessage( form, defaultMessage.id ));  
        
    }

    const handleSubmit=()=>{
        let form = new FormData()
       
      let startTime = moment( newMessageInfo.startTime , ['h:m a', 'H:m'] ).utc().format('HH:mm:ss');
      let endTime = moment(newMessageInfo.endTime , ['h:m a', 'H:m'] ).utc().format('HH:mm:ss');

      form.append('voice_message', "") 
      form.append('binary_files', "")
      form.append('message_type', 2)
      form.append('forward_type', 1)
      form.append('forward_date_time', null)
      form.append('is_active', 1)
      form.append( 'text_message', newMessageInfo.messageBody ) 
      form.append( 'name', newMessageInfo.name ) 

      form.append( 'start_time', startTime ) 
      form.append( 'end_time', endTime ) 
      
      form.append( 'active_days', getEncodedDays( newMessageInfo.days ) ) 
      form.append('timezone', moment.tz.guess())

      if( newMessageInfo.id ){
        dispatch(updatecustomMessage( form, newMessageInfo.id ));  
      } else {
        dispatch(updatecustomMessage( form ));  
      }    
    
    }

  return (
    <>
    <div className="row mt-5">

    {custommessages && custommessages.defaultWaitTime.length>0 && custommessages.defaultWaitTime.map((waitTime)=>{
         let local_date = moment.utc(waitTime.created_at && waitTime.created_at.replace(/-/g, '/')).local().format('MMM DD, hh:mm A');

        return (
<div key={waitTime.id} className="col-md-4 col-lg-4 col-sm-12 col-xs-12">
        <div className="basic-card">
            <div className="d-flex justify-content-between align-items-center">
                <div className="d-flex align-items-center">
                    <div className="head me-2">Default</div>
                    <div className="date">{local_date}</div>
                </div>
                <div data-bs-toggle="offcanvas"
                data-bs-target="#defaultMessageCanvas" aria-controls="defaultMessageCanvas" onClick={()=>setDefaultMessage(waitTime)}>
                    <img src={contactEditIcon} className="img-fluid"/>
                </div>
            </div>
            {/*<div className="subject">
                Hi thank you for calling the Cain Law Office.
        </div>*/}
            <div className="message">{waitTime.text_message.length>200?waitTime.text_message.slice(0,200)+'...':waitTime.text_message}
            </div>
        </div>
    </div>
        )
    })}
    
    
     {custommessages && custommessages.customWaitTime.map((waitTime)=>{
         let local_date = moment.utc(waitTime.created_at && waitTime.created_at.replace(/-/g, '/')).local().format('MMM DD, hh:mm A');
        return (
         <div key={waitTime.id} className="col-md-4 col-lg-4 col-sm-12 col-xs-12">
         <div className="basic-card">
             <div className="d-flex justify-content-between align-items-center">
                 <div className="d-flex align-items-center">
                     <div className="head me-2">{waitTime.name===null?("(empty)"):waitTime.name}</div>
                     <div className="date">{local_date}</div>
                 </div>
                 <div data-bs-toggle="offcanvas"
                 data-bs-target="#addCustomMessageCanvas" aria-controls="addCustomMessageCanvas" onClick={()=>customUpdateToggle(waitTime.id)}>
                     <img src={contactEditIcon} className="img-fluid"/>
                 </div>
             </div>
            {/* <div className="subject">
                 Hi thank you for calling the Cain Law Office.
     </div>*/}
             <div className="message">{ (waitTime && waitTime.text_message===null)?("(empty)"):        waitTime && waitTime.text_message && waitTime.text_message.length>200?waitTime.text_message.slice(0,200)+'...':waitTime.text_message}
             </div>
         </div>
     </div>
     
     )})}

    <div data-bs-toggle="offcanvas"
    data-bs-target="#addCustomMessageCanvas" aria-controls="addCustomMessageCanvas"
    className="col-md-4 col-lg-4 col-sm-12 col-xs-12" onClick={clearState}>
        <div className="custom-card">
            <div className="label">Add New Message</div>

        </div>
    </div>
</div>


<div className="offcanvas offcanvas-end" tabIndex="-1" id="addCustomMessageCanvas"
        aria-labelledby="addCustomMessageCanvasLabel">
        <div className="offcanvas-header">
            <h5 className="offcanvas-title" id="addCustomMessageCanvasLabel">Add Custom</h5>
            <button type="button" className="slider-close-btn" data-bs-dismiss="offcanvas"><img
                    src={sliderCloseIcon} className="img-fluid"/></button>
        </div>
        <div className="offcanvas-body">
            
            <div className="mt-2">
                <strong><label className="form-label">Label:</label></strong>
                <p>After an Hour</p>
            </div>
            <div className="mt-2">
             <input type="text" value={newMessageInfo.name} name="name" onChange={handleChangeInfo} className="form-control slider-inputs" placeholder="Title"/>
            </div>
            <div className="mt-2">
                <textarea className="form-control slider-inputs text-area-height" value={newMessageInfo.messageBody} name="messageBody" onChange={handleChangeInfo} placeholder="Message Body" aria-label="With textarea"></textarea>
            </div>
            <div className="mt-4 d-flex justify-content-between">
                <div>
                    <span>Start Time</span>
                    <input type="time" name="startTime" value={newMessageInfo.startTime} onChange={handleChangeInfo} className="form-control slider-inputs mt-1" placeholder="Start Time"/>
                </div>
                <div>
                    <span>End Time</span>
                    <input type="time" name="endTime" value={newMessageInfo.endTime} onChange={handleChangeInfo} className="form-control slider-inputs mt-1" placeholder="End Time"/>
                </div>
            </div>

            <div className="row mt-4">
                <strong><label className="form-label">Days:</label></strong>
                <div className="col-md-4 col-lg-4 col-sm-12 col-xs-12 mt-2">
                    <div className="form-check">
                        <input className="form-check-input" name="mon" checked={ newMessageInfo.days.mon }   onChange={ e  => { updateDaysCheckBox( e.target ) } } type="checkbox"  id="flexCheckDefault"/>
                        <label className="form-check-label" for="flexCheckDefault">
                          Monday
                        </label>
                      </div>
                </div>
                <div className="col-md-4 col-lg-4 col-sm-12 col-xs-12 mt-2">
                    <div className="form-check">
                        <input className="form-check-input" name="tue" checked={ newMessageInfo.days.tue }   onChange={ e  => { updateDaysCheckBox( e.target ) } } type="checkbox"  id="flexCheckDefault"/>
                        <label className="form-check-label" for="flexCheckDefault">
                          Tuesday
                        </label>
                      </div>
                </div>
                <div className="col-md-4 col-lg-4 col-sm-12 col-xs-12 mt-2">
                    <div className="form-check">
                        <input className="form-check-input" name="wed" checked={ newMessageInfo.days.wed }   onChange={ e  => { updateDaysCheckBox( e.target ) } } type="checkbox"  id="flexCheckDefault"/>
                        <label className="form-check-label" for="flexCheckDefault">
                          Wednesday
                        </label>
                      </div>
                </div>
                <div className="col-md-4 col-lg-4 col-sm-12 col-xs-12 mt-2">
                    <div className="form-check">
                        <input className="form-check-input" name="thu" checked={ newMessageInfo.days.thu }   onChange={ e  => { updateDaysCheckBox( e.target ) } } type="checkbox"  id="flexCheckDefault"/>
                        <label className="form-check-label" for="flexCheckDefault">
                          Thursday
                        </label>
                      </div>
                </div>
                <div className="col-md-4 col-lg-4 col-sm-12 col-xs-12 mt-2">
                    <div className="form-check">
                        <input className="form-check-input" name="fri" checked={ newMessageInfo.days.fri }   onChange={ e  => { updateDaysCheckBox( e.target ) } } type="checkbox"  id="flexCheckDefault"/>
                        <label className="form-check-label" for="flexCheckDefault">
                          Friday
                        </label>
                      </div>
                </div>
                <div className="col-md-4 col-lg-4 col-sm-12 col-xs-12 mt-2">
                    <div className="form-check">
                        <input className="form-check-input" name="sat" checked={ newMessageInfo.days.sat }   onChange={ e  => { updateDaysCheckBox( e.target ) } } type="checkbox"  id="flexCheckDefault"/>
                        <label className="form-check-label" for="flexCheckDefault">
                          Saturday
                        </label>
                      </div>
                </div>
                <div className="col-md-4 col-lg-4 col-sm-12 col-xs-12 mt-2">
                    <div className="form-check">
                        <input className="form-check-input" name="sun" checked={ newMessageInfo.days.sun }   onChange={ e  => { updateDaysCheckBox( e.target ) } } type="checkbox"  id="flexCheckDefault"/>
                        <label className="form-check-label" for="flexCheckDefault">
                          Sunday
                        </label>
                      </div>
                </div>
            </div>
            <div className="d-flex justify-content-end mt-4">
            <button className="slider-cancel-btn me-2" data-bs-dismiss="offcanvas"
            disabled={!dispatch(isAdminUser())}
            onClick={()=>dispatch(deleteCustomMessage(newMessageInfo.id))}
            >Delete</button>

                <button className="slider-cancel-btn me-2" data-bs-dismiss="offcanvas">Cancel</button>
                <button className="slider-success-btn" data-bs-dismiss="offcanvas" onClick={handleSubmit}>{newMessageInfo.id?"Update":"Add"}</button>
            </div>
        </div>
    </div>


    <div className="offcanvas offcanvas-end" tabIndex="-1" id="defaultMessageCanvas"
        aria-labelledby="defaultMessageCanvasLabel">
        <div className="offcanvas-header">
            <h5 className="offcanvas-title" id="defaultMessageCanvasLabel">Default</h5>
            <button type="button" className="slider-close-btn" data-bs-dismiss="offcanvas"><img
                    src={sliderCloseIcon} className="img-fluid"/></button>
        </div>
        <div className="offcanvas-body">
            
            <div className="mt-2">
                <strong><label className="form-label">Label:</label></strong>
                <p>Default</p>
            </div>
           {/* <div className="mt-2">
             <input type="text" className="form-control slider-inputs" placeholder="title" 
             value="Hi thank you for calling the Cain Law Office."
    />
            </div>*/}
            <div className="mt-5">
                <textarea value={defaultMessage.text_message} onChange={(e)=>setDefaultMessage({...defaultMessage,text_message:e.target.value})} className="form-control slider-inputs text-area-height" placeholder="Message Body" aria-label="With textarea"></textarea>
            </div>
            

            <div className="d-flex justify-content-end mt-4">
                <button className="slider-cancel-btn me-2" data-bs-dismiss="offcanvas">Cancel</button>
                <button className="slider-success-btn" data-bs-dismiss="offcanvas" onClick={handleUpdateDefault}>Update</button>
            </div>
        </div>
    </div>
</>
  )
}
